import React from "react";

const Gallery = () => {
        const images = [
        "/img/gallery/embedded_page3_img2.jpeg",
        "/img/gallery/embedded_page3_img3.jpeg",
        "/img/gallery/embedded_page3_img4.jpeg",
        "/img/gallery/embedded_page4_img3.jpeg",
        "/img/gallery/embedded_page4_img4.jpeg",
        "/img/gallery/embedded_page5_img2.jpeg",
        "/img/gallery/embedded_page5_img3.jpeg",
        "/img/gallery/embedded_page6_img2.jpeg",
        "/img/gallery/embedded_page6_img4.jpeg"
    ];
    const [modalOpen, setModalOpen] = React.useState(false);
    const [modalIndex, setModalIndex] = React.useState(0);

    const openModal = idx => { setModalIndex(idx); setModalOpen(true); };
    const closeModal = e => {
        if (e.target.classList.contains('gallery-modal') || e.target.classList.contains('close-modal')) {
            setModalOpen(false);
        }
    };
    const prevImg = () => setModalIndex(idx => idx > 0 ? idx - 1 : idx);
    const nextImg = () => setModalIndex(idx => idx < images.length - 1 ? idx + 1 : idx);

    return (
        <section id="gallery" className="container py-5">
            <h2 className="h3 mb-4">Galerie</h2>
            <div className="row g-3">
                {images.map((src, index) => (
                    <div className="col-sm-6 col-md-4 p-1" key={index}>
                        <img 
                            src={src} 
                            alt={`Galeriebild ${index + 1}`} 
                            className="img-fluid rounded shadow gallery-zoom-cursor" 
                            style={{
                                width: '100%',
                                height: '300px',
                                objectFit: 'cover',
                                transition: 'transform 0.3s ease',
                                cursor: 'zoom-in'
                            }}
                            onClick={() => openModal(index)}
                            onMouseOver={e => e.currentTarget.style.transform = 'scale(1.02)'}
                            onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
                            loading="lazy"
                        />
                    </div>
                ))}
            </div>
            {modalOpen && (
                <div className="gallery-modal" onClick={closeModal} style={{
                    position: 'fixed', zIndex: 1050, left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(24,24,28,0.88)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'opacity 0.2s', cursor: 'zoom-out'
                }}>
                    <div style={{position: 'relative', maxWidth: '96vw', maxHeight: '92vh', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <button className="close-modal btn btn-light btn-sm" style={{position: 'absolute', top: 10, right: 10, zIndex: 2, borderRadius: '50%', width: 36, height: 36, fontSize: 20, fontWeight: 700, opacity: 0.85}} aria-label="Schließen">×</button>
                        <img src={images[modalIndex]} alt={`Galeriebild ${modalIndex + 1}`} style={{maxWidth: '95vw', maxHeight: '80vh', borderRadius: '0.75rem', boxShadow: '0 4px 32px 0 rgba(0,0,0,0.18)'}} />
                        <div className="btn-group mt-3 mb-2">
                            <button onClick={prevImg} className="btn btn-outline-light" disabled={modalIndex === 0} style={{fontWeight: 500, opacity: modalIndex === 0 ? 0.7 : 1}}>← Zurück</button>
                            <button onClick={nextImg} className="btn btn-outline-light" disabled={modalIndex === images.length - 1} style={{fontWeight: 500, opacity: modalIndex === images.length - 1 ? 0.7 : 1}}>Weiter →</button>
                        </div>
                        <p className="text-light" style={{fontSize: '1rem'}} >Bild {modalIndex + 1} von {images.length}</p>
                    </div>
                </div>
            )}
        </section>
    );
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/Gallery.js